import { render, staticRenderFns } from "./SafeForWork2.vue?vue&type=template&id=8119213a&scoped=true&"
import script from "./SafeForWork2.vue?vue&type=script&lang=js&"
export * from "./SafeForWork2.vue?vue&type=script&lang=js&"
import style0 from "./SafeForWork2.vue?vue&type=style&index=0&id=8119213a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8119213a",
  null
  
)

export default component.exports